import React from "react";

export default function CartItem({ cartItem }) {
  const { size, nr, pName, count, total, extratopping, dressing } = cartItem;

  return (
    <div className="row mt-5 mt-lg-0 text-capitalize text-center align.items-center">
      <div className="col-10 mx-4 text-left col-lg-2 pb-2">
        <h6 className="font-weight-bold">
          {count}X{nr}.{pName}
        </h6>
        <span className="font-italic font-weight-light"> {size}</span>
      </div>
      <div className="col-10 mx-auto col-lg-2 pb-2">
        <p>
          {extratopping.map((topping) => {
            return <span key={topping}>{topping}, </span>;
          })}
          <span>{dressing}</span>
        </p>
      </div>
      <div className="col-10 mx-auto col-lg-2 my-2 my-lg-0"></div>
      <div className="col-10 mx-auto col-lg-2 ">
        <strong className="text-muted">{total} kr</strong>
      </div>
    </div>
  );
}
